import * as p from '@clack/prompts'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { cancelIfNeeded } from './cancel-if-needed.js'

export async function promptOptionalText(
  context: SchemaPromptContext,
  message: string
): Promise<string | undefined> {
  const value = await p.text({
    message,
    placeholder: 'Leave blank to skip'
  })

  const result = String(cancelIfNeeded(context, value)).trim()
  return result || undefined
}
